/**
 * DI-3-S42 — one number, three jobs, split (DI-D7 third revision, Christian
 * 2026-10-22). Until then the legacy 0.003° (333 m) grouped the drop,
 * searched the turbine register and gated a log against the images; a dense
 * old park (Vienna: two turbines 201 m apart) became one data set. Import the
 * one you mean — never a literal.
 *
 * Why 150 m for grouping and search: the lower bound is the offset between
 * two flights' averages on the SAME turbine (one flight may cover one blade:
 * up to ≈ the blade length — ≈ 90 m on a 180 m rotor); the upper bound is the
 * smallest spacing between turbines (201 m, Vienna).
 */

/** Two FLIGHT averages within this distance are one turbine — one data set. */
export const CLUSTER_RADIUS_M = 150;

/** The near query's radius — "which turbine of my register stands here?" (assets/v1 4.11.0 default). */
export const TURBINE_SEARCH_RADIUS_M = 150;

/** DI-D2 c4 — the log ↔ images position gate (the legacy 0.003°, Sync's plausibility bound). */
export const POSITION_GATE_M = 333;
